import { render, staticRenderFns } from "./notHandle.vue?vue&type=template&id=310d4cda&scoped=true&"
import script from "./notHandle.vue?vue&type=script&lang=js&"
export * from "./notHandle.vue?vue&type=script&lang=js&"
import style0 from "./notHandle.vue?vue&type=style&index=0&id=310d4cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310d4cda",
  null
  
)

export default component.exports